import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../api/api'
import { useTranslation } from 'react-i18next'
import { useProfileStore } from '../../store/useUserStore'
import { FaUserCheck } from "react-icons/fa";


const Inbox = () => {
    const navigate = useNavigate()
    const [notifications, setNotifications] = useState<any>([])
    const { t } = useTranslation()
    const {profile, setLoading} = useProfileStore((state) => state)

    useEffect(() => {
        if (!profile) return // Wait until profile is available
    
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/notification`).then(res => {
            console.log("notification", res.data.data)
            const inboxItem = { id: 0 } // id = 0 set as welcome notification
            setNotifications([...res.data.data, inboxItem])
        }).catch(err => {
            console.log("err cart", err)
        }).finally(()=>{
            setLoading(false)
        })
    }, [profile])

    function formatDate(dateString: string) {
        const date = new Date(dateString)

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kuala_Lumpur',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        })

        const parts = formatter.formatToParts(date)
        const partMap = Object.fromEntries(parts.map(p => [p.type, p.value]))

        const formattedDate = `${partMap.month} ${partMap.day}, ${partMap.year}, ${partMap.hour}:${partMap.minute} ${partMap.dayPeriod}`
        return formattedDate
    }

    function openNotification(notificationId:number) {
        setLoading(true)
        api.post(`${process.env.REACT_APP_API_BASE_URL}/notification/seen/${notificationId}`).then(res => {
            console.log("read", res.data)
        }).catch(err => {
            console.log("err cart", err)
        }).finally(()=>{
            setLoading(false)
            navigate(`/inbox/${notificationId}`)
        })
    }
    

    return (
        <div className="pb-28">
            <div className='mb-2 grid px-3'>
                <div className='text-lg font-medium'>{t("inbox.inbox")}</div>
            </div>

            {/* Quick Action Cards */}
            <div className="px-4 mb-6">
                <div className="bg-white rounded-2xl shadow-sm p-4">
                    <div className="flex gap-4">
                        {/* Homework Card */}
                        <div className="flex-1 flex flex-col items-center p-3 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer min-w-0"
                            onClick={() => navigate('/homework')}>
                            <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-2">
                                <svg className="w-6 h-6 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center">{t("inbox.HOMEWORK")}</span>
                        </div>

                        {/* Updates Card */}
                        {/* <div className="flex flex-col items-center p-3 rounded-xl  hover:bg-gray-100 transition-colors cursor-pointer">
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-2">
                                <svg className="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center">UPDATES</span>
                            <div className="w-2 h-2 bg-red-500 rounded-full mt-1"></div>
                        </div> */}

                        {/* Attendance Card */}
                        <div className="flex-1 flex flex-col items-center p-3 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer min-w-0" onClick={() => navigate('/attendance')}>
                            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-2">
                                <FaUserCheck color='#3b82f6 '/>
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center">{t("inbox.ATTENDANCE")}</span>
                        </div>

                        {/* Leave Card */}
                        {/* <div className="flex flex-col items-center p-3 rounded-xl  hover:bg-gray-100 transition-colors cursor-pointer">
                            <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-2">
                                <svg className="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M13 9V3.5L18.5 9M6 2C4.89 2 4 2.89 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2H6Z"/>
                                </svg>
                            </div>
                            <span className="text-xs font-medium text-gray-700 text-center">LEAVE</span>
                        </div> */}
                    </div>
                </div>
            </div>

            <div className="pb-2 py-2">
                {notifications.map((notification:any, index:number) => {
                    if (notification.id === 0) {
                        return (
                            <div key={index} className='grid grid-cols-12 gap-2 mx-2  p-2.5 items-center rounded-3xl mb-3 shadow-md' onClick={()=>{openNotification(notification.id)}}>
                                <div className='col-span-2'>
                                    <img src={"/assets/img/koku-logo.png"} alt="" className='w-10 h-10 rounded-3xl'/>
                                </div>
                                <div className='col-span-10 leading-tight'>
                                    <div className='text-md font-semibold m-0 p-0 truncate'>{t('notification_registration.greeting', { name: profile?.name })}</div>
                                    <div className='text-md font-semibold mb-1 p-0 truncate'>{t('notification_registration.welcome')}</div>
                                    <div className='text-md font-light m-0 p-0'>MYKOKU</div>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div key={index} className='grid grid-cols-12 gap-2 mx-2  p-2.5 items-center rounded-3xl mb-3 shadow-md' onClick={()=>{openNotification(notification.id)}}>
                                <div className='col-span-2'>
                                    <img src={notification.sender_pic || "/assets/img/koku-logo.png"} alt="" className='w-10 h-10 rounded-3xl'/>
                                </div>
                                <div className='col-span-6'>
                                    <div className={`text-md truncate ${notification.seen === false ? 'font-semibold' : 'font-light'}`}>{notification.title || "-"}</div>
                                    <div className={`text-md font-light truncate`}>{notification.sender_name || "-"}</div>
                                </div>
                                <div className={`col-span-4 text-xs ${notification.seen === false ? 'font-semibold' : 'font-light'} self-start`}>{notification.sent_at ? formatDate(notification.sent_at) : "-"}</div>
                            </div>
                        )
                    }
                })}
                
            </div>
        </div>
    )
}

export default Inbox